import { Injectable } from '@angular/core';
import { BackendApiService } from '@shared/core';
import { SESSION, USER_VEHICLES } from '../actions/index';
import { SessionInitAction } from '../actions/session-actions';
import {
	UserVehiclesDeleteAction,
	UserVehiclesDeleteFailureAction,
	UserVehiclesDeleteSuccessAction,
	UserVehiclesStartServiceAction
} from '../actions/user-vehicles-actions';
import { AuthService } from '../services';
import { Action } from '../action';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { empty, iif, Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { isServiceEnabled } from '../services-config';

@Injectable()
export class UserVehiclesEffects {
	@Effect({ dispatch: true })
	authStateSuccess$ = this.actions$.pipe(
		ofType<SessionInitAction>(SESSION.INIT),
		switchMap(action =>
			iif(() => isServiceEnabled('vehicles'), of(new UserVehiclesStartServiceAction(null, action.correlationId)), empty())
		)
	);

	@Effect()
	delete$: Observable<Action> = this.actions$.pipe(
		ofType<UserVehiclesDeleteAction>(USER_VEHICLES.DELETE),
		switchMap(x => {
			return this.backendApi.vehicleDelete(x.payload).pipe(
				map(r => new UserVehiclesDeleteSuccessAction(r, x.correlationId)),
				catchError(e => of(new UserVehiclesDeleteFailureAction(e, x.correlationId)))
			);
		})
	);

	constructor(
		private actions$: Actions,
		private store: Store<any>,
		private authService: AuthService,
		private backendApi: BackendApiService
	) {}
}
